import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import SettingsContainer from "../../containers/settings/SettingsContainer";
import PresentSettingsContainer from "../../containers/settings/slideshow/PresentSettingsContainer";
import SignupSettingsContainer from "../../containers/settings/SignupSettingsContainer";
import { languages } from "../../constants/languages";
import DesignSettingsContainer from "../../containers/settings/DesignSettingsContainer";
import { withWidth } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import InfoSettingsContainer from "../../containers/settings/InfoSettingsContainer";

class SettingsTabs extends React.Component {
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    let showPresentation =
      this.props.tournamentAdmin === undefined ||
      this.props.tournamentAdmin.managePresentation;
    let showPublicWebsite = true;
    let showSlideshow = true;
    let showDesign = true;
    if (this.props.tournamentAdmin) {
      showPublicWebsite =
        this.props.tournamentAdmin.managePublicWebsite ||
        this.props.tournamentAdmin.managePublicWebsite === undefined;
      showSlideshow =
        this.props.tournamentAdmin.manageSlideshow ||
        this.props.tournamentAdmin.manageSlideshow === undefined;
      showDesign =
        this.props.tournamentAdmin.manageDesign ||
        this.props.tournamentAdmin.manageDesign === undefined;
    }
    let showTabs = [];
    if (showPublicWebsite) {
      showTabs.push({
        label: languages.tournament.website_app,
        show: (
          <div>
            {this.props.signup ? (
              <SignupSettingsContainer
                user={this.props.user}
                userData={this.props.userData}
                tournament={this.props.tournament}
                divisions={this.props.divisions}
                userStatus={this.props.userStatus}
                tournamentStatus={this.props.tournamentStatus}
                tournamentAdmin={this.props.tournamentAdmin}
              />
            ) : this.props.tournamentInfo ? (
              <InfoSettingsContainer
                user={this.props.user}
                userData={this.props.userData}
                tournament={this.props.tournament}
                divisions={this.props.divisions}
                userStatus={this.props.userStatus}
                tournamentStatus={this.props.tournamentStatus}
                tournamentAdmin={this.props.tournamentAdmin}
              />
            ) : (
              <SettingsContainer
                tournament={this.props.tournament}
                userStatus={this.props.userStatus}
                tournamentStatus={this.props.tournamentStatus}
                toggleFinishedDialog={this.props.toggleFinishedDialog}
                upgrade={this.props.upgrade}
                user={this.props.user}
                liveLinkSettings={true}
                divisions={this.props.divisions}
                userData={this.props.userData}
              />
            )}
          </div>
        ),
      });
    }
    if (showSlideshow) {
      showTabs.push({
        label: languages.tournament.slideShow,
        show: (
          <div>
            <PresentSettingsContainer
              tournament={this.props.tournament}
              divisions={this.props.divisions}
              divisionsObject={this.props.divisionsObject}
              user={this.props.user}
              userData={this.props.userData}
              userStatus={this.props.userStatus}
              tournamentStatus={this.props.tournamentStatus}
            />
          </div>
        ),
      });
    }
    if (showDesign) {
      showTabs.push({
        label: languages.tournament.design,
        show: (
          <div>
            <DesignSettingsContainer
              tournament={this.props.tournament}
              userStatus={this.props.userStatus}
              tournamentStatus={this.props.tournamentStatus}
              user={this.props.user}
              userData={this.props.userData}
            />
          </div>
        ),
      });
    }
    return showPresentation ? (
      <div style={{ width: "100%" }}>
        <Paper style={{ maxWidth: 650, margin: "0 auto" }}>
          <Tabs
            centered={this.props.width !== "xs"}
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant={this.props.width === "xs" ? "scrollable" : "standard"}
            scrollButtons="off"
          >
            {showTabs.map((tab, i) => {
              return <Tab key={i} label={tab.label} />;
            })}
            {/* <Tab key={0} label={languages.tournament.publicWebsite} />
            <Tab key={1} label={languages.tournament.slideShow} />
            <Tab key={2} label={languages.tournament.design} /> */}
          </Tabs>
        </Paper>
        {showTabs.map((tab, i) => {
          return (
            <div
              key={i}
              style={{ display: this.state.value === i ? "initial" : "none" }}
            >
              {tab.show}
            </div>
          );
        })}
      </div>
    ) : (
      <div />
    );
  }
}

export default withWidth()(SettingsTabs);
